import Service from './service.js';
import '../uploader.js';

export class Matriculation extends Service {
    constructor() {
        super('#form-service-matriculation', 'matriculation');
        
        this.initService();
    };

    initService() {
        this.MatriculationStart = document.querySelector('#matriculation-matriculationstart');
        this.MatriculationEnd = document.querySelector('#matriculation-matriculationend');
        this.validated = true;
    };

    submit(event) {
        OVS.app.helper.toggleButton(true);
        if(typeof event !== 'undefined') {
            event.preventDefault();
        }
       
        let request = new Request('POST', this.form.getAttribute('action'));
        request.formData = this.form;
        request.call(response => {
            if(response.status == 'ok') {
                window.location.replace(response.redirect);
            } else {
                this.error(response.fields);
                OVS.app.helper.toggleButton(false);
            }
        });
    };
}